import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/user-context";
import {
  Container,
  Grid,
} from "@mui/material";
import "./style.scss";
import ProgramCard from "../../components/card/program-card";
import Banner from "../../components/banner/banner";

const CareerCoachingPay = (props: any) => {
  const { t, i18n } = useTranslation("content");
  const context = useContext(UserContext);


  useEffect(() => {
    document.title = "BSG:Career Coaching 职业发展培训计划:线上报名付款";

  }, [
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div >

        <Container maxWidth="md">
          <div>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignContent="flex-start"
            >
              <Grid container item xs={12} justifyContent="flex-start">
                <div>
                  <h1>线上报名付款</h1>
                  <h2>价格: $1,500.00 优惠价格: $998</h2>
                  <h2>1份职业报告+1次模拟面试+1v1辅导+无限次训练营课程=$998</h2>
                  <h2>长期价值 持续提升</h2>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <h2></h2>
              </Grid>
            </Grid>

          <div>
            <Container maxWidth="md">
              <Grid
                container
                spacing={6}
                direction="row"
                justifyContent="center"
              >
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  lg={8}
                  justifyContent="center"
                  alignContent="stretch"
                >
                  <ProgramCard
                    image="https://my-bsg-asset.s3.amazonaws.com/program/career_coaching.jpg"
                    title="BSG Career Coaching Program"
                    subtitle="Provided by BSG"
                    description=""
                    retailPrice={1500}
                    promoPrice={998}
                  >
                    <h2 className="center">线上报名付款 享受优惠价格</h2>
                    <h2 className="center">请使用PayPal安全电子支付方式付款</h2>
                  </ProgramCard>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>



</Container>
        
    </div>
  );
};

export default CareerCoachingPay;
